import { CaretDown } from "@phosphor-icons/react";
import { clsx } from "clsx";

import {
  Select,
  SelectContent,
  SelectItem,
  SelectItemText,
  SelectTrigger,
  SelectValue,
} from "common/components/ui/Select";
import SelectButton from "common/components/ui/SelectButton";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";

interface DelaySelectProps {
  delay: number;
  onChange: (value: number) => void;
  isDisabled: boolean;
  options: { value: number; label: string }[];
  isError: boolean;
}

export default function DelaySelect({
  delay,
  onChange,
  isDisabled,
  options,
  isError,
}: DelaySelectProps) {
  const isDesktop = useTwBreakpoint("lg");

  if (isDesktop) {
    return (
      <Select
        value={delay.toString()}
        onValueChange={(newValue) => onChange(Number(newValue))}
        disabled={isDisabled}
      >
        <SelectTrigger asChild>
          <SelectButton size="sm" hasSelection={!!delay}>
            <SelectValue />
          </SelectButton>
        </SelectTrigger>
        <SelectContent className="max-h-60">
          {options.map(({ value, label }) => (
            <SelectItem value={value.toString()} key={value}>
              <SelectItemText>{label}</SelectItemText>
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    );
  }
  return (
    <div className="grid w-full items-center">
      <select
        value={delay}
        disabled={isDisabled}
        onChange={(e) => onChange(Number(e.currentTarget.value))}
        className={clsx(
          "col-start-1 row-start-1 h-12 w-full appearance-none rounded-2xl p-2 text-button-md outline-none transition-colors disabled:cursor-not-allowed disabled:text-black-400",
          isError
            ? "bg-red-50 text-red-500 ring-2 ring-red-300"
            : "bg-whiteGray text-black-700 focus-visible:text-black-950 focus-visible:ring-2 focus-visible:ring-purple-200",
        )}
      >
        {options.map(({ value: optionValue, label }) => (
          <option value={optionValue} key={optionValue}>
            {label}
          </option>
        ))}
      </select>
      <CaretDown
        size={20}
        className="pointer-events-none col-start-1 row-start-1 mx-2 ml-auto"
      />
    </div>
  );
}
